<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav" :class="mainStatus === 'online' && 'active'" @click.stop="handleClick('online')">{{$t('apiDoc.在线文档')}}</span>
      <span class="main-r_top_nav" :class="mainStatus === 'apiTest' && 'active'" @click.stop="handleClick('apiTest')">{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'order/interOuterAddOrder';
export default {
  components: { onlineDoc, apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_10')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [

          //   请求头参数
          {
            title: `${this.$t('onlineDoc.Headers')}`,
            value: [
              { name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
              { name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`, },
              { name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`, },
              { name: "digestType", type: "Number", require: "N", normal: "", describe: `${this.$t('onlineDoc.签名类型')}`, },
            ]
          },
          {
            title: `${this.$t('onlineDoc.请求参数')}`,
            value: [
              { name: "bizContent", type: "String", require: "Y", normal: `${this.$t('onlineDoc.业务参数')}`, describe: `${this.$t('onlineDoc.业务参数，各接口的入参json报文')}`, },
            ]
          },
          {
            title: `${this.$t('onlineDoc.业务参数')}`,
            value: [
              { name: "customerCode", type: "String(30)", require: "Y", normal: "J0086024071", describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}` },
              { name: "digest", type: "String(50)", require: "Y", normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`, describe: `${this.$t('onlineDoc.signnew')}` },
              { name: "txlogisticId", type: "String(50)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.客户订单号（传客户自己系统的订单号）')}` },
              { name: "expressType", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.internationalExportExpressType')}` },
              { name: "serviceType", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.服务类型')}` },
              { name: "serviceTypeCode", type: "String(30)", require: "N", normal: "", describe: `${this.$t('onlineDoc.默认C03-出国国际件')}` },
              { name: "deliveryType", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.派送类型')}` },
              { name: "payType", type: "String(30)", require: "N", normal: "", describe: `${this.$t('onlineDoc.paymentMethod')}` },
              { name: "sender", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.寄件信息对象')}` },
              { name: "receiver", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.收件信息对象')}` },
              { name: "sendStartTime", type: "String(30)", require: "N", normal: "", describe: `${this.$t('onlineDoc.LC_pick_up_start_time')}` },
              { name: "sendEndTime", type: "String(30)", require: "N", normal: "", describe: `${this.$t('onlineDoc.CLC_door_to_door_end_time')}` },
              { name: "goodsType", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.itemtType')}` },
              { name: "length", type: "int(6)", require: "N", normal: "", describe: `${this.$t('onlineDoc.Length')}` },
              { name: "width", type: "int(6)", require: "N", normal: "", describe: `${this.$t('onlineDoc.Width')}` },
              { name: "height", type: "int(6)", require: "N", normal: "", describe: `${this.$t('onlineDoc.Height')}` },
              { name: "weight", type: "String(12)", require: "Y", normal: "0.02", describe: `${this.$t('onlineDoc.Weight')}` },
              { name: "totalQuantity", type: "int(4)", require: "N", normal: "", describe: `${this.$t('onlineDoc.包裹总票数')}` },
              { name: "remark", type: "String(200)", require: "N", normal: "", describe: `${this.$t('onlineDoc.备注')}` }
            ]
          },
          {
            title: `${this.$t('onlineDoc.sender类型说明')}`,
            value: [
              { name: "name", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.寄件人姓名')}` },
              { name: "company", type: "String(100)", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件公司')}` },
              { name: "postCode", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件邮编')}` },
              { name: "mailBox", type: "String(150)", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件邮箱')}` },
              { name: "mobile", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.SendingMobilePhone')}` },
              { name: "phone", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.SendingPhoneNumber')}` },
              { name: "countryCode", type: "String(20)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.CharacterSending')}` },
              { name: "prov", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.寄件酋长国')}` },
              { name: "city", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.寄件区域')}` },
              { name: "area", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.区域1')}` },
              { name: "street", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件街道')}` },
              { name: "address", type: "String(200)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.ShippingDetailedAddress')}` },
              { name: "areaCode", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件区号')}` },
              { name: "longitude", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件经度')}` },
              { name: "latitude", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('onlineDoc.寄件纬度')}` },
              {name: "buildingNumber",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件建筑物编号')}`},
              {name: "secondaryNumber",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件辅助编号')}`},
              {name: "shortAddress",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件短地址')}`}
            ]
          },
          {
            title: `${this.$t('onlineDoc.receiver类型说明')}`,
            value: [
              { name: "name", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.收件人姓名')}` },
              { name: "receiverIdNumber", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件人证件号码')}` },
              { name: "company", type: "String(100)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件公司')}` },
              { name: "postCode", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件邮编')}` },
              { name: "mailBox", type: "String(150)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件邮箱')}` },
              { name: "mobile", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.ReceivingMobilephone')}` },
              { name: "phone", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.ReceivingPhoneNumber')}` },
              { name: "countryCode", type: "String(20)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.CharacterRecipient')}` },
              { name: "prov", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.收件酋长国')}` },
              { name: "city", type: "String(32)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.收件区域')}` },
              { name: "area", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.区域2')}` },
              { name: "street", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件街道')}` },
              { name: "address", type: "String(200)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.ReceivingDetailedAddress')}` },
              { name: "areaCode", type: "String(32)", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件区号')}` },
              { name: "longitude", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件经度')}` },
              { name: "latitude", type: "BigDecimal", require: "N", normal: "", describe: `${this.$t('onlineDoc.收件纬度')}` },
              {name: "buildingNumber",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件建筑物编号')}`},
              {name: "secondaryNumber",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件辅助编号')}`},
              {name: "shortAddress",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件短地址')}`}
            ]
          },
          {
            title: `${this.$t('onlineDoc.items类型说明')}`,
            value: [
              { name: "itemType", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.物品类型')}` },
              { name: "itemName", type: "String(100)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.物品名称')}` },
              {name: "chineseName",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.物品中文名称')}`},
              {name: "englishName",type: "String(60)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.物品英文名称')}`},
              { name: "number", type: "int(4)", require: "N", normal: "", describe: `${this.$t('onlineDoc.数量')}` },
              { name: "itemValue", type: "String(20)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.申报价值(数值型)')}` },
              { name: "priceCurrency", type: "String(20)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.priceCurrency')}` },
              { name: "desc", type: "String(100)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.物品描述')}` },
              { name: "itemUrl", type: "String(100)", require: "N", normal: "", describe: `${this.$t('onlineDoc.商品URL')}` },
              { name: "hsCode", type: "String(100)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.海关编码')}` },
              { name: "purposeOfShipment", type: "String(100)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.purposeOfShipment')}`},
              { name: "placeOfOrigin", type: "String(500)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.原产地')}`}
            ]
          },
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [

          //   响应参数
          {
            title: `${this.$t('onlineDoc.响应参数')}`,
            value: [
              { name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}` },
              { name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}` },
              { name: "data", type: "Object", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}` },
            ]
          },
          {
            title: `${this.$t('onlineDoc.data类型说明')}`,
            value: [
              { name: "txlogisticId", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回客户订单号')}` },
              { name: "createOrderTime", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.订单创建时间')}` },
              { name: "billCode", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.运单号')}` },
              { name: "sortingCode", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.三段码online')}` },
              { name: "sumFreight", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.参考总运费')}` }
            ]
          }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    digest=dv7y+k4Pth0asb/tf7IOtg==
    timestamp=1638428570653

Body：{"bizContent": "{"customerCode":"J0086024071","deliveryType":"04","digest":"9umKtVQpenun6Dm2d4Ot/w==","expressType":"EZKSA","goodsType":"ITN5","height":15,"items":[{"chineseName":"无线耳机","desc":"High quality wireless headphones with noise cancellation","englishName":"Wireless Headphones","hsCode":"8518300000","itemName":"Wireless Headphones","itemType":"ITN5","itemUrl":"https://example.com/product/123456","itemValue":"150.00","number":1,"placeOfOrigin":"SA","priceCurrency":"AED","purposeOfShipment":"2"},{"chineseName":"手机","desc":"High quality wireless headphones with noise cancellation","englishName":"Wireless Headphones","hsCode":"8518300000","itemName":"Wireless Headphones","itemType":"ITN5","itemUrl":"https://example.com/product/123456","itemValue":"150.00","number":1,"placeOfOrigin":"KWT","priceCurrency":"AED","purposeOfShipment":"1"}],"length":30,"payType":"PP_PM","receiver":{"address":"Riyadh Riyadh King Fahd Road No.123","area":"Olaya","areaCode":"011","city":"Riyadh","company":"Saleh Imports","countryCode":"SA","latitude":24.713552,"longitude":46.675297,"mailBox":"mohammed.saleh@example.com","mobile":"0558765432","name":"Mohammed Saleh","phone":"0111234567","postCode":"56789","prov":"Riyadh","receiverIdNumber":"SA9001014839","street":"King Fahd Road"},"remark":"Handle with care","sendEndTime":"2025-09-22 12:00:00","sendStartTime":"2025-09-22 10:00:00","sender":{"address":"Dubai Dubai Al Maktoum Road No.88","area":"Deira","areaCode":"04","city":"Dubai","company":"Ali Trading LLC","countryCode":"UAE","latitude":25.276987,"longitude":55.296249,"mailBox":"ali.hassan@example.com","mobile":"0501234567","name":"Ali Hassan","phone":"0209876543","postCode":"12345","prov":"Dubai","street":"Al Maktoum Road"},"serviceType":"01","serviceTypeCode":"C03","totalQuantity":1,"txlogisticId":"OPEN1758767686782317767","weight":0.50,"width":20}`,
        //返回示例
        responseCode: JSON.parse(
          `{
  "code": "1",
  "msg": "success",
  "data": {
    "txlogisticId": "OPEN1758767686782317767",
    "createOrderTime": "2025-09-25 05:34:48",
    "billCode": "UTE300010467874"
  }
}`
        ),
        //错误代码提示
        errcodeJson: [
          { code: '145003031', msg: `${this.$t('apiTestDoc.业务参数签名失败')}` },
          {code:'145003082',msg:`${this.$t('apiTestDoc.客户订单号不能为空或过长')}`},
          { code: '1450033330', msg: `${this.$t('apiTestDoc.总数量不能超过 999')}` },
          { code: '145003081', msg: `${this.$t('apiTestDoc.客户编码不合法')}` },
          { code: '145003083', msg: `${this.$t('apiTestDoc.发件人信息不完整')}` },
          { code: '145003084', msg: `${this.$t('apiTestDoc.收件人信息不完整')}` },
          { code: '1450033329', msg: `${this.$t('apiTestDoc.手机号码长度错误')}` },
          { code: '1450033315', msg: `${this.$t('apiTestDoc.请填写正确的寄件省份')}` },
          { code: '1450033318', msg: `${this.$t('apiTestDoc.COD代收货款不能超过3万')}` },
          { code: '1450033319', msg: `${this.$t('apiTestDoc.货到付款金额不能小于')}` },
          { code: '145003095', msg: `${this.$t('apiTestDoc.货品类型信息不完整')}` },
          { code: '145003200', msg: `${this.$t('apiTestDoc.请检查服务类型是否合法（仅支持 01 或 02）')}` },
          { code: '1450033313', msg: `${this.$t('apiTestDoc.请填写正确的派送类型')}` },
          { code: '1450033312', msg: `${this.$t('apiTestDoc.请填写正确的运输类型')}` },
          { code: '1450033327', msg: `${this.$t('apiTestDoc.快递类型错误')}` },
          { code: '1450033331', msg: `${this.$t('apiTestDoc.服务类型代码校验失败')}` },
          { code: '145005101', msg: `${this.$t('apiTestDoc.仓库标识错误')}` },
          { code: '145005106', msg: `${this.$t('apiTestDoc.条码不能为空')}` },
          { code: '145005104', msg: `${this.$t('apiTestDoc.商品编码不能为空')}` },
          { code: '145005105', msg: `${this.$t('apiTestDoc.SKU 编码不能为空')}` },
          { code: '145005110', msg: `${this.$t('apiTestDoc.参数长度超过最大限制')}` },
          { code: '145005501', msg: `${this.$t('apiTestDoc.运费不能小于 0')}` },
          { code: '145005502', msg: `${this.$t('apiTestDoc.运费不合法')}` },
          { code: '145005503', msg: `${this.$t('apiTestDoc.收货地址与客户所在位置不一致')}` },
          { code: '145005504', msg: `${this.$t('apiTestDoc.未找到收件人国家')}` },
          { code: '145005505', msg: `${this.$t('apiTestDoc.币种不合法')}` },
          { code: '145005506', msg: `${this.$t('apiTestDoc.订单申报币种不匹配')}` },
          { code: '145005507', msg: `${this.$t('apiTestDoc.寄件国家编码或者名称不能为空')}` },
          { code: '145005508', msg: `${this.$t('apiTestDoc.高价值包裹必须填写收件人证件号码')}` },
          { code: '145005510', msg: `${this.$t('apiTestDoc.订单申报币种')}` },
          { code: '145005511', msg: `${this.$t('apiTestDoc.货物寄送目的填写错误')}` }
        ]
      },

      apiTestData: {
        _headerData: {
          apiAccount: "292508153084379141",
          digest: "dv7y+k4Pth0asb/tf7IOtg==",
          timestamp: "1638428570653",
        },
        data: {
          bizContent: `{"customerCode":"J0086024071","deliveryType":"04","digest":"9umKtVQpenun6Dm2d4Ot/w==","expressType":"EZKSA","goodsType":"ITN5","height":15,"items":[{"chineseName":"无线耳机","desc":"High quality wireless headphones with noise cancellation","englishName":"Wireless Headphones","hsCode":"8518300000","itemName":"Wireless Headphones","itemType":"ITN5","itemUrl":"https://example.com/product/123456","itemValue":"150.00","number":1,"placeOfOrigin":"SA","priceCurrency":"AED","purposeOfShipment":"2"},{"chineseName":"手机","desc":"High quality wireless headphones with noise cancellation","englishName":"Wireless Headphones","hsCode":"8518300000","itemName":"Wireless Headphones","itemType":"ITN5","itemUrl":"https://example.com/product/123456","itemValue":"150.00","number":1,"placeOfOrigin":"KWT","priceCurrency":"AED","purposeOfShipment":"1"}],"length":30,"payType":"PP_PM","receiver":{"address":"Riyadh Riyadh King Fahd Road No.123","area":"Olaya","areaCode":"011","city":"Riyadh","company":"Saleh Imports","countryCode":"SA","latitude":24.713552,"longitude":46.675297,"mailBox":"mohammed.saleh@example.com","mobile":"0558765432","name":"Mohammed Saleh","phone":"0111234567","postCode":"56789","prov":"Riyadh","receiverIdNumber":"SA9001014839","street":"King Fahd Road"},"remark":"Handle with care","sendEndTime":"2025-09-22 12:00:00","sendStartTime":"2025-09-22 10:00:00","sender":{"address":"Dubai Dubai Al Maktoum Road No.88","area":"Deira","areaCode":"04","city":"Dubai","company":"Ali Trading LLC","countryCode":"UAE","latitude":25.276987,"longitude":55.296249,"mailBox":"ali.hassan@example.com","mobile":"0501234567","name":"Ali Hassan","phone":"0209876543","postCode":"12345","prov":"Dubai","street":"Al Maktoum Road"},"serviceType":"01","serviceTypeCode":"C03","totalQuantity":1,"txlogisticId":"OPEN1758767686782317767","weight":0.50,"width":20}`
        },
        // 必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        // 触发接口
        apiUrl: `/mock/${apiUrlTest}`,
        // 返回
        ResponseJson: "",
        // 当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


        //错误代码提示
        errcodeJson: [
        { code: '145003031', msg: `${this.$t('apiTestDoc.业务参数签名失败')}` },
          {code:'145003082',msg:`${this.$t('apiTestDoc.客户订单号不能为空或过长')}`},
          { code: '1450033330', msg: `${this.$t('apiTestDoc.总数量不能超过 999')}` },
          { code: '145003081', msg: `${this.$t('apiTestDoc.客户编码不合法')}` },
          { code: '145003083', msg: `${this.$t('apiTestDoc.发件人信息不完整')}` },
          { code: '145003084', msg: `${this.$t('apiTestDoc.收件人信息不完整')}` },
          { code: '1450033329', msg: `${this.$t('apiTestDoc.手机号码长度错误')}` },
          { code: '1450033315', msg: `${this.$t('apiTestDoc.请填写正确的寄件省份')}` },
          { code: '1450033318', msg: `${this.$t('apiTestDoc.COD代收货款不能超过3万')}` },
          { code: '1450033319', msg: `${this.$t('apiTestDoc.货到付款金额不能小于')}` },
          { code: '145003095', msg: `${this.$t('apiTestDoc.货品类型信息不完整')}` },
          { code: '145003200', msg: `${this.$t('apiTestDoc.请检查服务类型是否合法（仅支持 01 或 02）')}` },
          { code: '1450033313', msg: `${this.$t('apiTestDoc.请填写正确的派送类型')}` },
          { code: '1450033312', msg: `${this.$t('apiTestDoc.请填写正确的运输类型')}` },
          { code: '1450033327', msg: `${this.$t('apiTestDoc.快递类型错误')}` },
          { code: '1450033331', msg: `${this.$t('apiTestDoc.服务类型代码校验失败')}` },
          { code: '145005101', msg: `${this.$t('apiTestDoc.仓库标识错误')}` },
          { code: '145005106', msg: `${this.$t('apiTestDoc.条码不能为空')}` },
          { code: '145005104', msg: `${this.$t('apiTestDoc.商品编码不能为空')}` },
          { code: '145005105', msg: `${this.$t('apiTestDoc.SKU 编码不能为空')}` },
          { code: '145005110', msg: `${this.$t('apiTestDoc.参数长度超过最大限制')}` },
          { code: '145005501', msg: `${this.$t('apiTestDoc.运费不能小于 0')}` },
          { code: '145005502', msg: `${this.$t('apiTestDoc.运费不合法')}` },
          { code: '145005503', msg: `${this.$t('apiTestDoc.收货地址与客户所在位置不一致')}` },
          { code: '145005504', msg: `${this.$t('apiTestDoc.未找到收件人国家')}` },
          { code: '145005505', msg: `${this.$t('apiTestDoc.币种不合法')}` },
          { code: '145005506', msg: `${this.$t('apiTestDoc.订单申报币种不匹配')}` },
          { code: '145005507', msg: `${this.$t('apiTestDoc.寄件国家编码或者名称不能为空')}` },
          { code: '145005508', msg: `${this.$t('apiTestDoc.高价值包裹必须填写收件人证件号码')}` },
          { code: '145005510', msg: `${this.$t('apiTestDoc.订单申报币种')}` },
          { code: '145005511', msg: `${this.$t('apiTestDoc.货物寄送目的填写错误')}` }]
      },
    };
  },
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>